import { ProjectSettingsModeEnum } from '@/app/api';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const ProjectFinishedMoreStoriesHeadline: React.FC<{
  actualSuccess: boolean;
  projectMode: ProjectSettingsModeEnum;
}> = ({ actualSuccess, projectMode }) => {
  const { t } = useTranslation();

  const projectFinishedMoreStoriesHeadline = useMemo(() => {
    if (projectMode === ProjectSettingsModeEnum.DonioPlus) {
      if (actualSuccess) {
        return t('pages.collection.projectSuccessfulMoreStoriesHeadline');
      }

      return t('pages.collection.projectClosedMoreStoriesHeadline');
    }

    if (actualSuccess) {
      return t('pages.collection.charityCollectionSuccessfulMoreStoriesHeadline');
    }

    return t('pages.collection.charityCollectionClosedMoreStoriesHeadline');
  }, [actualSuccess, projectMode]);

  return (
    <h2 className="h-[120px] text-center mb-[40px] text-balance text-[24px] lg:text-[32px] leading-[32px] lg:leading-[40px] bg-no-repeat bg-bottom whitespace-pre-line">
      {projectFinishedMoreStoriesHeadline}
    </h2>
  );
};
